import AppLayout from '../../components/Layout'
import React from 'react'

export default function Material() {
  return (
    <div>Material</div>
  )
}
